import {push} from 'connected-react-router';
import {APPLICATION_STATUS, PAGE_NAME, SUBMIT_API} from '../../../../config/DEConstants';
import {buildCapeTxnRunner} from '../../../../../framework/App/CapeTransaction';
const runDeApplyCapeTxn = buildCapeTxnRunner('de_apply');
import axios from 'axios';
import {FORM_ID, NETWORK} from '../../../../../framework/App/AppConstants';
import _ from 'lodash';
import {scrollToTop} from '../../../../../framework/App/SkeletonPage/SkeletonPageActions';
import {spinnerClose} from '../../../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import {change, SubmissionError, untouch, focus} from 'redux-form';
import {processSubmissionErrors} from '../../../../../shared-components/FormElement/FormElementUtils';
import {setServerData} from '../../../../../framework/store/ServerData/ServerDataActions';
import setUrl from '../../../../../framework/App/SetUrl';
import {trackTransition} from '../../../../../framework/store/FPTI/FPTIActions';
import {USER_TITLE_FIELD, DOB_FIELD, PHONE_NUMBER_FIELD} from './PersonalInfoFormConstants';
import moment from 'moment';
import {safeStringify} from '../../../../../../../server/src/CAP/GPL/util/stringUtil';

export const handleRedirect = (response) => {
    if (response && _.get(response, 'data.redirect')) {
        setUrl(window, response.data.redirect);
        return true;
    }
    return false;
};

export const showSoftDecline = () => dispatch => {
    //for clearing out field on soft-decline
    dispatch(change(FORM_ID, `${USER_TITLE_FIELD}`, ''));
    dispatch(untouch(FORM_ID, `${USER_TITLE_FIELD}`));
    dispatch(focus(FORM_ID, `${USER_TITLE_FIELD}`));
    dispatch(change(FORM_ID, `${DOB_FIELD}`, ''));
    dispatch(untouch(FORM_ID, `${DOB_FIELD}`));
    dispatch(change(FORM_ID, `${PHONE_NUMBER_FIELD}`, ''));
    dispatch(untouch(FORM_ID, `${PHONE_NUMBER_FIELD}`));
};

export const submitApplication = (data, localePrefix) => (dispatch, getState) => {
    return runDeApplyCapeTxn(() => {
        const state = getState();
        const { serverData = {} } = state;
        const { _csrf = '' } = serverData;

        return axios
            .request({
                url: SUBMIT_API,
                method: 'post',
                headers: {
                    ...NETWORK.REQUEST.XHR.HEADER,
                    'X-CSRF-Token': _csrf
                },
                data
            }).then(response => {
                if (!_.isEmpty(_.get(response, 'data.validation.errors'))) {
                    dispatch(scrollToTop());
                    dispatch(spinnerClose());
                    capeLog && capeLog(`submitApplicationApi:de:response: server validation error: ${safeStringify(response.data.validation.errors)}`);
                    return Promise.reject(new SubmissionError(processSubmissionErrors(response.data.validation.errors.fieldError, localePrefix), state));
                } else {
                    if (handleRedirect(response)) {
                        return;
                    }
                    dispatch(spinnerClose());
                    dispatch(setServerData({
                        decisionModel: response.data,
                        invalidAddressMsg: _.get(response, 'data.showInvalidAddress'),
                        showValidationSoftDecline: _.get(response, 'data.showValidationSoftDecline'),
                        showInvalidAddressSoftDecline: _.get(response, 'data.showInvalidAddress'),
                    }));
                    const appStatus = _.get(response, 'data.applicationStatus');
                    capeLog && capeLog(`submitApplicationApi:de:response: applicationStatus: ${appStatus}`);
                    const extra = {};
                    extra.ppc_status = appStatus;

                    if (appStatus === APPLICATION_STATUS.PENDING) {
                        dispatch(push(PAGE_NAME.TERMS_PAGE));
                        dispatch(setServerData({
                            // success, hide soft decline warn banner
                            showValidationSoftDecline: false,
                            showInvalidAddressSoftDecline: false,
                        }));
                    } else if (appStatus === APPLICATION_STATUS.SOFT_DECLINE || appStatus === APPLICATION_STATUS.ANS_SOFT_DECLINE) {
                        dispatch(trackTransition('pp_credit_personalinfopage', 'prepare_pp_credit_personalinfopage', extra));
                        dispatch(showSoftDecline());
                    } else {
                        dispatch(push(PAGE_NAME.DECISION_PAGE));
                    }
                }
            }).catch(error => {
                if (error instanceof SubmissionError) {
                    return Promise.reject(error);
                }
                capeLog && capeLog('response:error, DE_PersonalInfoFormActions,' + (error && error.message));

                if (handleRedirect(error && error.response)) {
                    return;
                }
                if (_.get(error, 'response.data.err', false)) {
                    dispatch(setServerData({ errorModel: _.get(error, 'response.data', {}) }));
                    dispatch(push(PAGE_NAME.ERROR_PAGE));
                    dispatch(spinnerClose());
                } else {
                    // should never be here
                    capeLog && capeLog('response:error: unexpected error response for Application Pahe submit');
                    setUrl(window, PAGE_NAME.ERROR_PAGE);
                }
            });
    });
};

